export function parseCookies() {
  return window.document.cookie
    .split(';')
    .map((v) => v.split('='))
    .reduce<Record<string, string>>((acc, [key, val]) => {
      if (val) acc[decodeURIComponent(key.trim())] = decodeURIComponent(val.trim())
      return acc
    }, {})
}
